import { render, staticRenderFns } from "./CheckboxButton.vue?vue&type=template&id=50595349&scoped=true"
import script from "./CheckboxButton.vue?vue&type=script&lang=ts"
export * from "./CheckboxButton.vue?vue&type=script&lang=ts"
import style0 from "./CheckboxButton.vue?vue&type=style&index=0&id=50595349&prod&lang=sass&scoped=true"
import style1 from "./CheckboxButton.vue?vue&type=style&index=1&id=50595349&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50595349",
  null
  
)

export default component.exports